export const ASSESSMENT_MODE_LITE_TO_FULL = "lite_to_full";
export const ASSESSMENT_MODE_FULL_ONLY = "full_only";

export const DEFAULT_ASSESSMENT_MODE = ASSESSMENT_MODE_LITE_TO_FULL;
export const DEFAULT_OFFER_LITE_REPORT = "Y";

export function assessmentModeLabel(mode) {
  return mode === ASSESSMENT_MODE_FULL_ONLY
    ? "Full assessment only"
    : "LITE, then full assessment";
}

export function defaultInviteOptions() {
  return {
    assessment_mode: DEFAULT_ASSESSMENT_MODE,
    offer_lite_report: DEFAULT_OFFER_LITE_REPORT,
  };
}
